import { useState } from "react";
import { useAuthContext } from '@/context/AuthContext';
import {userManager} from '@/components/authentication/keycloak.js';

export const useGenerateFiduciaryReport = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const generateFiduciaryReport = async (expenseUuids) => {
    setLoading(true);
    setError(null);
    const user = await userManager.getUser();
    try {
      const response = await fetch(`${window.ENV.BACKEND_URL}/api/secured/admin/expense/generateFiduciaryReport`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.access_token}`,
        },
        body: JSON.stringify({ expenseReportsUuids: expenseUuids }), // Envoi de la liste d'UUIDs
      });

      if (!response.ok) {
        throw new Error("Failed to generate fiduciary report");
      }

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      setData({ url, type: blob.type });
      return { url, type: blob.type };
    } catch (err) {
      setError(err.message);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { generateFiduciaryReport, loading, error, data };
};
